import React from 'react';

export const DropzoneIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="25" viewBox="0 0 29 25" fill="none">
    <path
      d="M26.0409 3.5346H21.3054L18.938 0H9.46857L7.10121 3.5346H2.36736C1.7395 3.5346 1.13735 3.78286 0.693383 4.22477C0.249417 4.66668 0 5.26604 0 5.891V22.3858C0 23.0107 0.249417 23.6101 0.693383 24.052C1.13735 24.4939 1.7395 24.7422 2.36736 24.7422H26.0409C26.6688 24.7422 27.271 24.4939 27.7149 24.052C28.1589 23.6101 28.4083 23.0107 28.4083 22.3858V5.891C28.4083 5.26604 28.1589 4.66668 27.7149 4.22477C27.271 3.78286 26.6688 3.5346 26.0409 3.5346ZM14.2042 18.8512C13.1507 18.8512 12.1208 18.5402 11.2449 17.9577C10.3689 17.3751 9.68621 16.547 9.28306 15.5782C8.8799 14.6094 8.77442 13.5434 8.97994 12.5149C9.18547 11.4865 9.69278 10.5418 10.4377 9.80029C11.1826 9.0588 12.1317 8.55384 13.165 8.34927C14.1982 8.1447 15.2692 8.24969 16.2425 8.65098C17.2158 9.05227 18.0477 9.73182 18.633 10.6037C19.2183 11.4756 19.5307 12.5007 19.5307 13.5493C19.5307 14.9554 18.9695 16.304 17.9706 17.2983C16.9717 18.2926 15.6168 18.8512 14.2042 18.8512Z"
      fill="#21282B"
    />
    <ellipse cx="11.6542" cy="12.2348" rx="0.728418" ry="0.725046" fill="#21282B" />
    <ellipse cx="16.7533" cy="12.2348" rx="0.728418" ry="0.725046" fill="#21282B" />
    <path
      d="M16.5716 14.4105C16.2074 14.9543 15.2969 15.498 14.2043 15.498C13.1116 15.498 12.2011 14.9543 11.8369 14.4105"
      stroke="#21282B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
